export const MIN_WIDGET_HEIGHT = 0.45;
export const MAX_LENGTH_URL = 10000;
export const MAX_LENGHT_NAME = 256;
